import React, { Component } from 'react';
import {
    Paper,
    Box,
    Card,
    CardContent,
    CardHeader,
    Collapse,
    IconButton,
    TextField,
    Button,
    Checkbox,
    FormControlLabel,
    List,
    ListItem,
    ListItemText,
    Dialog,
    DialogContent,
    DialogActions,
    withStyles,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    CircularProgress
} from '@material-ui/core';
import {
    ExpandMore,
    ExpandLess,
    AddPhotoAlternate,
    Description,
    Save,
    ArrowBack,
    Delete,
} from '@material-ui/icons';
import Swal from 'sweetalert2';
import BreadcrumbLayout from "../../shared/components/common/breadcrumbLayout";

import { EquipmentService } from './service';


const styles = theme => ({
    root: {
        padding: theme.spacing(2),
        backgroundColor: '#f8f9fa',
        minHeight: '100vh',
    },
    sectionCard: {
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 6,
        marginBottom: theme.spacing(2),
        backgroundColor: '#fff',
        boxShadow: '0 2px 6px rgba(0, 0, 0, .1)',
        overflow: 'hidden',
    },
    sectionHeader: {
        cursor: 'pointer',
        padding: theme.spacing(1, 2),
        backgroundColor: '#f8f9fa',
        fontWeight: 'bold',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        '&:hover': {
            backgroundColor: '#e9ecef',
        },
    },
    sectionBody: {
        padding: theme.spacing(2),
    },
    sugestoesList: {
        position: 'absolute',
        zIndex: 10,
        width: '100%',
        maxHeight: 200,
        overflowY: 'auto',
        backgroundColor: 'white',
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 4,
    },
    fotoContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(1),
        marginTop: theme.spacing(1),
    },
    fotoItem: {
        position: 'relative',
        display: 'inline-block',
    },
    fotoThumb: {
        width: 120,
        height: 120,
        objectFit: 'cover',
        cursor: 'pointer',
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 4,
    },
    deleteButton: {
        position: 'absolute',
        top: 0,
        right: 0,
        minWidth: 'auto',
        padding: 4,
        backgroundColor: 'rgba(255,255,255,0.8)',
    },
    laudoItem: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    disabledSection: {
        pointerEvents: 'none',
        opacity: 0.5,
    },
});

class AdminAddEquipPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Hierarquia
            categorias: [],
            produtos: [],
            servicos: [],
            loadingCategorias: false,
            loadingProdutos: false,
            loadingServicos: false,

            equipamentoAtual: null,
            sections: {
                dados: true,
                fotos: true,
                laudos: true
            },
            formData: {
                categoria_id: '',
                produto_id: '',
                servico_id: '',
                marca: '',
                modelo: '',
                serie: '',
                ca: '',
                obstec: '',
                localizacao: '',
                proxima_revisao: '',
                ultima_revisao: '',
                ativo: true
            },
            fotos: {
                antes: [],
                depois: []
            },
            laudos: [],
            modalImagemAberta: false,
            imagemModalUrl: '',
        };
    }

    async componentDidMount() {
        await this.carregarCategorias();

        const editId = localStorage.getItem("add_equip_edit");
        if (editId) {
            await this.carregarEquipamento(editId);
        }
    }

    carregarCategorias = async () => {
        this.setState({ loadingCategorias: true });
        try {
            const categorias = await EquipmentService.getCategorias();
            this.setState({ categorias, loadingCategorias: false });
        } catch (error) {
            console.error('Erro ao carregar categorias:', error);
            this.setState({ loadingCategorias: false });
        }
    };

    carregarEquipamento = async (id) => {
        const equip = await EquipmentService.loadEquipment(id);

        this.setState({
            equipamentoAtual: equip,
            formData: {
                categoria_id: equip.categoria_id || '',
                produto_id: equip.produto_id || '',
                servico_id: equip.servico_id || '',
                marca: equip.marca,
                modelo: equip.modelo,
                serie: equip.serie,
                ca: equip.ca,
                obstec: equip.obstec,
                localizacao: equip.localizacao,
                proxima_revisao: equip.proxima_revisao,
                ultima_revisao: equip.ultima_revisao,
                ativo: equip.ativo
            },
            fotos: {
                antes: equip.fotos.filter(f => f.momento === "antes"),
                depois: equip.fotos.filter(f => f.momento === "depois"),
            },
            laudos: equip.laudos
        });

        // Carregar dependentes
        if (equip.categoria_id) {
            try {
                const produtos = await EquipmentService.getProdutosByCategoria(equip.categoria_id);
                this.setState({ produtos });
                if (equip.produto_id) {
                    const servicos = await EquipmentService.getServicosByProduto(equip.produto_id);
                    this.setState({ servicos });
                }
            } catch (e) {
                console.error('Erro ao carregar dependências:', e);
            }
        }
    };

    toggleSection = (section) => {
        this.setState(prev => ({
            sections: { ...prev.sections, [section]: !prev.sections[section] }
        }));
    };

    handleCategoriaChange = async (event) => {
        const categoriaId = event.target.value;
        this.setState(prev => ({
            formData: { ...prev.formData, categoria_id: categoriaId, produto_id: '', servico_id: '' },
            produtos: [],
            servicos: [],
            loadingProdutos: true
        }));

        if (!categoriaId) {
            this.setState({ loadingProdutos: false });
            return;
        }

        try {
            const produtos = await EquipmentService.getProdutosByCategoria(categoriaId);
            this.setState({ produtos, loadingProdutos: false });
        } catch (error) {
            this.setState({ loadingProdutos: false });
        }
    };

    handleProdutoChange = async (event) => {
        const produtoId = event.target.value;
        this.setState(prev => ({
            formData: { ...prev.formData, produto_id: produtoId, servico_id: '' },
            servicos: [],
            loadingServicos: true
        }));

        if (!produtoId) {
            this.setState({ loadingServicos: false });
            return;
        }

        try {
            const servicos = await EquipmentService.getServicosByProduto(produtoId);
            this.setState({ servicos, loadingServicos: false });
        } catch (error) {
            this.setState({ loadingServicos: false });
        }
    };

    handleServicoChange = (event) => {
        const servicoId = event.target.value;
        this.setState(prev => ({
            formData: { ...prev.formData, servico_id: servicoId }
        }));
    };

    handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;

        this.setState(prev => ({
            formData: {
                ...prev.formData,
                [name]: type === "checkbox" ? checked : value
            }
        }));
    };

    handleAtivoChange = (e) => {
        const ativo = e.target.checked;
        const { currentLanguage } = this.props;

        if (!ativo) {
            Swal.fire(currentLanguage.bepiService.admin.admin_add_equip_swal_attention_title, currentLanguage.bepiService.admin.admin_add_equip_swal_remove_warning_text, "warning");
        }

        this.setState(prev => ({
            formData: { ...prev.formData, ativo }
        }));
    };

    salvarEquipamento = async () => {
        const { formData, equipamentoAtual } = this.state;
        const { currentLanguage } = this.props;

        if (!formData.servico_id) {
            Swal.fire(currentLanguage.bepiService.admin.admin_add_equip_swal_error_title, currentLanguage.bepiService.admin.admin_add_equip_swal_invalid_service_text, "error");
            return;
        }

        const id = equipamentoAtual?.id ?? null;

        const saved = await EquipmentService.saveEquipment(formData, id);

        Swal.fire(currentLanguage.bepiService.admin.admin_add_equip_swal_success_title, currentLanguage.bepiService.admin.admin_add_equip_swal_save_success_text, "success");

        this.setState({ equipamentoAtual: { id: saved.id } });
        localStorage.setItem("add_equip_edit", saved.id);
    };

    escolherFoto = (momento) => {
        const { currentLanguage } = this.props;
        if (!this.state.equipamentoAtual) {
            Swal.fire(currentLanguage.bepiService.admin.admin_add_equip_swal_attention_title, currentLanguage.bepiService.admin.admin_add_equip_swal_save_first_text, "warning");
            return;
        }

        const input = document.createElement("input");
        input.type = "file";
        input.accept = "image/*";
        input.multiple = true;

        input.onchange = async (e) => {
            const files = [...e.target.files];

            for (const file of files) {
                const blob = await this.resizeImage(file, 1000);
                const foto = await EquipmentService.uploadPhoto(
                    this.state.equipamentoAtual.id,
                    momento,
                    blob
                );

                this.setState(prev => ({
                    fotos: {
                        ...prev.fotos,
                        [momento]: [...prev.fotos[momento], foto]
                    }
                }));
            }
        };

        input.click();
    };

    resizeImage = (file, maxSize) => {
        return new Promise(resolve => {
            const reader = new FileReader();
            reader.onload = e => {
                const img = new Image();
                img.onload = () => {
                    let w = img.width;
                    let h = img.height;

                    if (w > h && w > maxSize) { h *= maxSize / w; w = maxSize; }
                    else if (h > maxSize) { w *= maxSize / h; h = maxSize; }

                    const canvas = document.createElement("canvas");
                    canvas.width = w;
                    canvas.height = h;

                    canvas.getContext("2d").drawImage(img, 0, 0, w, h);
                    canvas.toBlob(resolve, "image/jpeg", 0.85);
                };
                img.src = e.target.result;
            };
            reader.readAsDataURL(file);
        });
    };

    excluirFoto = async (id) => {
        const { currentLanguage } = this.props;
        const ok = await Swal.fire({
            title: currentLanguage.bepiService.admin.admin_add_equip_swal_remove_photo_title,
            icon: "warning",
            showCancelButton: true
        });

        if (!ok.isConfirmed) return;

        await EquipmentService.deletePhoto(id);

        this.setState(prev => ({
            fotos: {
                antes: prev.fotos.antes.filter(f => f.id !== id),
                depois: prev.fotos.depois.filter(f => f.id !== id)
            }
        }));

        Swal.fire(currentLanguage.bepiService.admin.admin_add_equip_swal_success_title, currentLanguage.bepiService.admin.admin_add_equip_swal_remove_photo_success_text, "success");
    };

    prepararLaudo = () => {
        const { currentLanguage } = this.props;
        if (!this.state.equipamentoAtual) {
            Swal.fire(currentLanguage.bepiService.admin.admin_add_equip_swal_attention_title, currentLanguage.bepiService.admin.admin_add_equip_swal_save_first_text, "warning");
            return;
        }

        const input = document.createElement("input");
        input.type = "file";
        input.accept = "application/pdf";

        input.onchange = async (e) => {
            const file = e.target.files[0];

            const nome = prompt(currentLanguage.bepiService.admin.admin_add_equip_prompt_laudo_name, file.name.replace(".pdf", ""));
            if (!nome) return;

            const laudo = await EquipmentService.uploadLaudo(
                this.state.equipamentoAtual.id,
                nome,
                file
            );

            this.setState(prev => ({
                laudos: [...prev.laudos, laudo]
            }));
        };

        input.click();
    };

    excluirLaudo = async (id) => {
        const { currentLanguage } = this.props;
        const ok = await Swal.fire({
            title: currentLanguage.bepiService.admin.admin_add_equip_swal_remove_laudo_title,
            icon: "warning",
            showCancelButton: true
        });

        if (!ok.isConfirmed) return;

        await EquipmentService.deleteLaudo(id);

        this.setState(prev => ({
            laudos: prev.laudos.filter(l => l.id !== id)
        }));

        Swal.fire(currentLanguage.bepiService.admin.admin_add_equip_swal_success_title, currentLanguage.bepiService.admin.admin_add_equip_swal_remove_laudo_success_text, "success");
    };

    renderDadosEquipamento = () => {
        const { classes, currentLanguage } = this.props;
        const {
            formData,
            categorias, produtos, servicos,
            loadingCategorias, loadingProdutos, loadingServicos
        } = this.state;

        return (
            <Box className={classes.sectionBody}>

                {/* Seleção hierárquica: Categoria → Produto → Serviço */}
                <Box display="flex" gap={2} flexWrap="wrap" mb={2}>
                    <FormControl variant="outlined" size="small" style={{ flex: '1 1 280px', minWidth: 200 }}>
                        <InputLabel id="adm-categoria-label">Categoria</InputLabel>
                        <Select
                            labelId="adm-categoria-label"
                            id="adm-select-categoria"
                            value={formData.categoria_id}
                            onChange={this.handleCategoriaChange}
                            label="Categoria"
                            disabled={loadingCategorias}
                        >
                            <MenuItem value=""><em>{loadingCategorias ? 'Carregando...' : 'Selecione a categoria'}</em></MenuItem>
                            {categorias.map(cat => (
                                <MenuItem key={cat.id} value={cat.id}>{cat.nome}</MenuItem>
                            ))}
                        </Select>
                        {loadingCategorias && <Box display="flex" alignItems="center" gap={1} mt={0.5} style={{ fontSize: '0.85rem', color: '#999' }}><CircularProgress size={14} /> Carregando...</Box>}
                    </FormControl>

                    <FormControl variant="outlined" size="small" style={{ flex: '1 1 280px', minWidth: 200 }}>
                        <InputLabel id="adm-produto-label">Produto</InputLabel>
                        <Select
                            labelId="adm-produto-label"
                            id="adm-select-produto"
                            value={formData.produto_id}
                            onChange={this.handleProdutoChange}
                            label="Produto"
                            disabled={!formData.categoria_id || loadingProdutos}
                        >
                            <MenuItem value=""><em>{!formData.categoria_id ? 'Selecione a categoria primeiro' : loadingProdutos ? 'Carregando...' : produtos.length === 0 ? 'Nenhum produto' : 'Selecione o produto'}</em></MenuItem>
                            {produtos.map(prod => (
                                <MenuItem key={prod.id} value={prod.id}>{prod.nome}</MenuItem>
                            ))}
                        </Select>
                        {loadingProdutos && <Box display="flex" alignItems="center" gap={1} mt={0.5} style={{ fontSize: '0.85rem', color: '#999' }}><CircularProgress size={14} /> Carregando...</Box>}
                    </FormControl>

                    <FormControl variant="outlined" size="small" style={{ flex: '1 1 280px', minWidth: 200 }}>
                        <InputLabel id="adm-servico-label">Serviço</InputLabel>
                        <Select
                            labelId="adm-servico-label"
                            id="adm-select-servico"
                            value={formData.servico_id}
                            onChange={this.handleServicoChange}
                            label="Serviço"
                            disabled={!formData.produto_id || loadingServicos}
                        >
                            <MenuItem value=""><em>{!formData.produto_id ? 'Selecione o produto primeiro' : loadingServicos ? 'Carregando...' : servicos.length === 0 ? 'Nenhum serviço' : 'Selecione o serviço'}</em></MenuItem>
                            {servicos.map(srv => (
                                <MenuItem key={srv.id} value={srv.id}>{srv.nome}</MenuItem>
                            ))}
                        </Select>
                        {loadingServicos && <Box display="flex" alignItems="center" gap={1} mt={0.5} style={{ fontSize: '0.85rem', color: '#999' }}><CircularProgress size={14} /> Carregando...</Box>}
                    </FormControl>
                </Box>

                <TextField fullWidth margin="normal" name="marca" label={currentLanguage.bepiService.admin.admin_add_equip_label_brand} value={formData.marca} onChange={this.handleInputChange} />
                <TextField fullWidth margin="normal" name="modelo" label={currentLanguage.bepiService.admin.admin_add_equip_label_model} value={formData.modelo} onChange={this.handleInputChange} />
                <TextField fullWidth margin="normal" name="serie" label={currentLanguage.bepiService.admin.admin_add_equip_label_series} value={formData.serie} onChange={this.handleInputChange} />
                <TextField fullWidth margin="normal" name="ca" label={currentLanguage.bepiService.admin.admin_add_equip_label_ca} value={formData.ca} onChange={this.handleInputChange} />
                <TextField fullWidth margin="normal" name="obstec" label={currentLanguage.bepiService.admin.admin_add_equip_label_obs_tech} value={formData.obstec} onChange={this.handleInputChange} />
                <TextField fullWidth margin="normal" name="localizacao" label={currentLanguage.bepiService.admin.admin_add_equip_label_location} value={formData.localizacao} onChange={this.handleInputChange} />

                <TextField fullWidth type="date" name="proxima_revisao" label={currentLanguage.bepiService.admin.admin_add_equip_label_next_revision} InputLabelProps={{ shrink: true }} margin="normal" value={formData.proxima_revisao} onChange={this.handleInputChange} />
                <TextField fullWidth type="date" name="ultima_revisao" label={currentLanguage.bepiService.admin.admin_add_equip_label_last_revision} InputLabelProps={{ shrink: true }} margin="normal" value={formData.ultima_revisao} onChange={this.handleInputChange} />

                <FormControlLabel
                    control={<Checkbox checked={formData.ativo} onChange={this.handleAtivoChange} />}
                    label={currentLanguage.bepiService.admin.admin_add_equip_label_active}
                />

                <Box display="flex" gap={1} mt={2}>
                    <Button variant="outlined" startIcon={<ArrowBack />} onClick={() => window.history.back()}>
                        {currentLanguage.bepiService.admin.admin_add_equip_btn_back}
                    </Button>

                    <Button variant="contained" color="primary" startIcon={<Save />} onClick={this.salvarEquipamento}>
                        {currentLanguage.bepiService.admin.admin_add_equip_btn_save}
                    </Button>
                </Box>
            </Box>
        );
    };

    renderFotos = () => {
        const { classes, currentLanguage } = this.props;
        const { fotos, equipamentoAtual } = this.state;

        const bloqueado = !equipamentoAtual;

        return (
            <Box className={`${classes.sectionBody} ${bloqueado ? classes.disabledSection : ''}`}>

                <Button
                    variant="contained"
                    color="primary"
                    startIcon={<AddPhotoAlternate />}
                    onClick={() => this.escolherFoto("antes")}
                >
                    {currentLanguage.bepiService.admin.admin_add_equip_btn_add_photo_before}
                </Button>

                <Box className={classes.fotoContainer}>
                    {fotos.antes.map(f => (
                        <Box key={f.id} className={classes.fotoItem}>
                            <img
                                src={`/api/fotos/${f.nome_arquivo}`}
                                className={classes.fotoThumb}
                                onClick={() => this.setState({ modalImagemAberta: true, imagemModalUrl: `/api/fotos/${f.nome_arquivo}` })}
                            />

                            <IconButton className={classes.deleteButton} size="small" onClick={() => this.excluirFoto(f.id)}>
                                <Delete />
                            </IconButton>
                        </Box>
                    ))}
                </Box>

                <Button
                    variant="contained"
                    color="primary"
                    startIcon={<AddPhotoAlternate />}
                    style={{ marginTop: 16 }}
                    onClick={() => this.escolherFoto("depois")}
                >
                    {currentLanguage.bepiService.admin.admin_add_equip_btn_add_photo_after}
                </Button>

                <Box className={classes.fotoContainer}>
                    {fotos.depois.map(f => (
                        <Box key={f.id} className={classes.fotoItem}>
                            <img
                                src={`/api/fotos/${f.nome_arquivo}`}
                                className={classes.fotoThumb}
                                onClick={() => this.setState({ modalImagemAberta: true, imagemModalUrl: `/api/fotos/${f.nome_arquivo}` })}
                            />

                            <IconButton className={classes.deleteButton} size="small" onClick={() => this.excluirFoto(f.id)}>
                                <Delete />
                            </IconButton>
                        </Box>
                    ))}
                </Box>

            </Box>
        );
    };

    renderLaudos = () => {
        const { classes, currentLanguage } = this.props;
        const { laudos, equipamentoAtual } = this.state;

        const bloqueado = !equipamentoAtual;

        return (
            <Box className={`${classes.sectionBody} ${bloqueado ? classes.disabledSection : ''}`}>
                <Button
                    variant="contained"
                    color="primary"
                    startIcon={<Description />}
                    onClick={this.prepararLaudo}
                    style={{ marginBottom: 16 }}
                >
                    {currentLanguage.bepiService.admin.admin_add_equip_btn_send_laudo}
                </Button>

                {laudos.map(l => (
                    <Box key={l.id} className={classes.laudoItem}>
                        <Button href={`/api/laudos/${l.nome_arquivo}`} target="_blank">
                            {l.nome}
                        </Button>
                        <IconButton size="small" onClick={() => this.excluirLaudo(l.id)}>
                            <Delete />
                        </IconButton>
                    </Box>
                ))}
            </Box>
        );
    };

    renderModalImagem = () => {
        const { modalImagemAberta, imagemModalUrl } = this.state;
        const { currentLanguage } = this.props;

        return (
            <Dialog open={modalImagemAberta} onClose={() => this.setState({ modalImagemAberta: false })} maxWidth="lg">
                <DialogContent>
                    <img src={imagemModalUrl} alt="" style={{ width: '100%', height: 'auto' }} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.setState({ modalImagemAberta: false })}>
                        {currentLanguage.bepiService.admin.admin_add_equip_btn_close}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    };

    render() {
        const { classes } = this.props;
        const { sections } = this.state;
        const { currentLanguage } = this.props
        const breadcrumbItems = [
            { label: currentLanguage.bepiService.shared.shared_breadcrumb_home, path: '/bepi/admin' },
            { label: currentLanguage.bepiService.shared.shared_breadcrumb_equipments, path: '/bepi/admin/equipaments' },
            { label: currentLanguage.bepiService.admin.admin_breadcrumb_add_equipment },
        ];

        return (
            <BreadcrumbLayout
                title={currentLanguage.bepiService.admin.admin_breadcrumb_add_equipment}
                breadcrumbItems={breadcrumbItems}
                currentLanguage={currentLanguage}
                showBackButton
            >
                <Box className={classes.root}>

                    <Card className={classes.sectionCard}>
                        <CardHeader
                            title={currentLanguage.bepiService.admin.admin_add_equip_card_title_data}
                            action={
                                <IconButton onClick={() => this.toggleSection("dados")}>
                                    {sections.dados ? <ExpandLess /> : <ExpandMore />}
                                </IconButton>
                            }
                            className={classes.sectionHeader}
                        />
                        <Collapse in={sections.dados}>
                            <CardContent style={{ padding: 0 }}>
                                {this.renderDadosEquipamento()}
                            </CardContent>
                        </Collapse>
                    </Card>

                    <Card className={classes.sectionCard}>
                        <CardHeader
                            title={currentLanguage.bepiService.admin.admin_add_equip_card_title_photos}
                            action={
                                <IconButton onClick={() => this.toggleSection("fotos")}>
                                    {sections.fotos ? <ExpandLess /> : <ExpandMore />}
                                </IconButton>
                            }
                            className={classes.sectionHeader}
                        />
                        <Collapse in={sections.fotos}>
                            <CardContent style={{ padding: 0 }}>
                                {this.renderFotos()}
                            </CardContent>
                        </Collapse>
                    </Card>

                    <Card className={classes.sectionCard}>
                        <CardHeader
                            title={currentLanguage.bepiService.admin.admin_add_equip_card_title_laudos}
                            action={
                                <IconButton onClick={() => this.toggleSection("laudos")}>
                                    {sections.laudos ? <ExpandLess /> : <ExpandMore />}
                                </IconButton>
                            }
                            className={classes.sectionHeader}
                        />
                        <Collapse in={sections.laudos}>
                            <CardContent style={{ padding: 0 }}>
                                {this.renderLaudos()}
                            </CardContent>
                        </Collapse>
                    </Card>

                    {this.renderModalImagem()}

                </Box>
            </BreadcrumbLayout>
        );
    }
}

export default withStyles(styles)(AdminAddEquipPage);

